import mori from 'mori';
import { digColumnValue } from '../util/util';

/**
 * @param data
 * @param metaData
 * @param baseColumn
 * @param childColumn
 * @param ...key
 */
export default function getSelectedColumnsRecursive() {
  const args = Array.prototype.slice.call(arguments);
  const data = args[0];
  const metaData = args[1];
  const baseColumn = args[2];
  const childColumn = args[3];
  const keys = args.slice(4, args.length);

  if (mori.count(mori.keys(mori.last(keys[0]))) > 0) {
    return mori.into(
      mori.vector(),
      mori.mapcat(
        (row) => {
          return getSelectedColumnsRecursive(
            data,
            metaData,
            baseColumn,
            childColumn,
            row,
            ...keys
          );
        },
        mori.last(keys[0])
      )
    );
  }
  const nestedObject = digColumnValue(
    metaData.columns,
    ...keys.map((item) => mori.first(item)).reverse()
  ) || {};

  // KFF-2245.  If no label, the key does not exist in the data.
  // Simply return to prevent parsing `undefined` later
  if (!nestedObject.label) {
    return null;
  }

  return getColumn(keys[0], nestedObject, baseColumn, childColumn);
}

function getColumn(row, nestedObject, baseColumn, childColumn) {
  const base = mori.hashMap(
    baseColumn,
    nestedObject.label
  );
  return mori.isEmpty(mori.last(row)) ?
    mori.vector(mori.vector(base)) :
    mori.map(
      (child) => {
        // summary rows gets a rewrite
        if (mori.first(child) === 'summary') {
          return mori.set([
            mori.hashMap(
              baseColumn,
              `${nestedObject.label} (All)`
            ),
            mori.hashMap(
              childColumn,
              null
            ),
          ]);
        }
        return mori.set([
          base,
          mori.hashMap(
            childColumn,
            nestedObject.children[mori.first(child)].label
          ),
        ]);
      },
      mori.last(row)
    );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getSelectedColumnsRecursive.js